/**
 * TAS Command — Sistema Digitale di Gestione Operazioni SAR
 *
 * Copyright (c) 2026 Matteo MESSINA, Alfonso CECERE
 * Tutti i diritti riservati.
 *
 * Sviluppato dagli autori a titolo personale, al di fuori
 * dell'orario di servizio e senza utilizzo di risorse o
 * strumentazione dell'amministrazione di appartenenza.
 *
 * Qualsiasi riproduzione, distribuzione o utilizzo non
 * autorizzato è vietato ai sensi della L. 633/1941.
 *
 * Autori:
 *   Matteo MESSINA  — VE, Comando VVF Benevento, Servizio TAS
 *   Alfonso CECERE  — VE, Comando VVF Benevento, Servizio TAS
 */

/**
 * Struttura Regioni → Comandi → Sedi VVF italiane.
 * Fonte: "Comandi e sedi VVF-Regione.xlsx" — 569 righe, 18 regioni.
 * Dati statici importati nel frontend per i dropdown a cascata del Profilo.
 */

export const VVF_DATA = {
  "Abruzzo": {
    "CHIETI": ["Sede centrale","Casoli","Lanciano","Ortona","Vasto"],
    "L'AQUILA": ["Sede centrale","Avezzano","Castel di Sangro","Sulmona"],
    "PESCARA": ["Sede centrale","Alanno","Penne","Pescara Aeroporto"],
    "TERAMO": ["Sede centrale","Nereto","Roseto degli Abruzzi"]
  },
  "Basilicata": {
    "MATERA": ["Sede centrale","Ferrandina","Pisticci","Policoro"],
    "POTENZA": ["Sede centrale","Lauria","Marsicovetere","Melfi","Palazzo San Gervasio","Pescopagano"]
  },
  "Calabria": {
    "CATANZARO": ["Sede centrale","Chiaravalle Centrale","Lamezia Terme","Sellia Marina","Soverato","Lamezia Terme Aeroporto"],
    "COSENZA": ["Sede centrale","Castrovillari","Corigliano-Rossano","Paola","Rende","Scalea","San Giovanni in Fiore"],
    "CROTONE": ["Sede centrale","Cirò Marina","Petilia Policastro","Crotone Sant'Anna Aeroporto"],
    "REGGIO CALABRIA": ["Sede centrale","Bianco","Melito di Porto Salvo","Monasterace","Palmi","Polistena","Siderno","Villa San Giovanni","Reggio Calabria Aeroporto"],
    "VIBO VALENTIA": ["Sede centrale","Vibo Marina","Ricadi","Serra San Bruno"]
  },
  "Campania": {
    "AVELLINO": ["Sede centrale","Bisaccia","Grottaminarda","Lioni","Montella"],
    "BENEVENTO": ["Sede centrale","Bonea","San Marco dei Cavoti","Telese Terme"],
    "CASERTA": ["Sede centrale","Aversa","Marcianise","Mondragone","Piedimonte Matese","Teano"],
    "NAPOLI": [
      "Sede centrale","Napoli Centro Storico","Napoli Mostra","Napoli Orientale","Napoli Pianura",
      "Napoli Ponticelli","Napoli Scampia","Napoli Vomero","Giugliano in Campania","Afragola",
      "Capri","Castellammare di Stabia","Ischia","Nola","Pozzuoli","Sorrento","Torre del Greco",
      "Napoli Aeroporto"
    ],
    "SALERNO": [
      "Sede centrale","Salerno Città","Agropoli","Eboli","Giffoni Valle Piana","Maiori",
      "Mercato San Severino","Nocera Inferiore","Sala Consilina","Santa Marina","Sarno",
      "Vallo della Lucania", "Aeroporto Costa d'Amalfi"
    ]
  },
  "Emilia-Romagna": {
    "BOLOGNA": ["Sede centrale","Bologna Carlo Fava","Budrio","Imola","Pianoro","San Lazzaro di Savena","Vergato","Zola Predosa","Bologna Aeroporto"],
    "FERRARA": ["Sede centrale","Cento","Codigoro","Comacchio","Portomaggiore"],
    "FORLÌ-CESENA": ["Sede centrale","Bagno di Romagna","Cesena","Rocca San Casciano","Forlì aeroporto"],
    "MODENA": ["Sede centrale","Carpi","Pavullo nel Frignano","San Felice sul Panaro","Sassuolo","Vignola"],
    "PARMA": ["Sede centrale","Fidenza","Langhirano","Val di Taro","Parma Aeroporto"],
    "PIACENZA": ["Sede centrale","Bobbio","Castel San Giovanni","Fiorenzuola d'Arda"],
    "RAVENNA": ["Sede centrale","Ravenna Candiano","Cervia","Faenza","Lugo"],
    "REGGIO EMILIA": ["Sede centrale","Castelnovo ne' Monti","Guastalla","Sant'Ilario d'Enza"],
    "RIMINI": ["Sede centrale","Cattolica","Novafeltria","Rimini Aeroporto"]
  },
  "Friuli-Venezia Giulia": {
    "GORIZIA": ["Sede centrale","Monfalcone","Gorizia Aeroporto"],
    "PORDENONE": ["Sede centrale","Maniago","San Vito al Tagliamento","Spilimbergo"],
    "TRIESTE": ["Sede centrale","Trieste Opicina","Muggia"],
    "UDINE": ["Sede centrale","Cervignano del Friuli","Cividale del Friuli","Gemona del Friuli","Latisana","Tarvisio","Tolmezzo"]
  },
  "Lazio": {
    "FROSINONE": ["Sede centrale","Cassino","Fiuggi","Sora"],
    "LATINA": ["Sede centrale","Aprilia","Castelforte","Gaeta","Terracina"],
    "RIETI": ["Sede centrale","Poggio Mirteto","Posta"],
    "ROMA": [
      "Sede centrale","Roma EUR","Roma Fluviale","Roma La Pisana","Roma La Rustica","Roma Monte Mario",
      "Roma Nomentano","Ostia","Roma Ostiense","Roma Prati","Roma Tuscolano 1","Roma Tuscolano 2",
      "Roma Via del Calice","Anzio","Bracciano","Campagnano di Roma","Cerveteri","Civitavecchia",
      "Colleferro","Frascati","Marino","Montelibretti","Palestrina","Pomezia","Subiaco","Tivoli",
      "Velletri","Roma Ciampino Aeroporto","Roma Fiumicino Aeroporto"
    ],
    "VITERBO": ["Sede centrale","Civita Castellana","Gradoli","Tarquinia"]
  },
  "Liguria": {
    "GENOVA": ["Sede centrale","Genova Bolzaneto","Genova Est","Genova Levante","Genova Multedo","Busalla","Chiavari","Rapallo","Genova Aeroporto"],
    "IMPERIA": ["Sede centrale","Sanremo","Ventimiglia"],
    "LA SPEZIA": ["Sede centrale","Brugnato","Sarzana"],
    "SAVONA": ["Sede centrale","Albenga","Cairo Montenotte","Finale Ligure","Varazze","Savona Aeroporto"]
  },
  "Lombardia": {
    "BERGAMO": ["Sede centrale","Clusone","Dalmine","Zogno","Bergamo Aeroporto"],
    "BRESCIA": ["Sede centrale","Brescia San Polo","Darfo Boario Terme","Gardone Val Trompia","Salò","Brescia Montichiari Aeroporto"],
    "COMO": ["Sede centrale","Cantù","Menaggio"],
    "CREMONA": ["Sede centrale","Crema"],
    "LECCO": ["Sede centrale"],
    "LODI": ["Sede centrale"],
    "MANTOVA": ["Sede centrale","Castiglione delle Stiviere","Suzzara","Viadana"],
    "MILANO": ["Sede centrale","Milano Cuoco","Milano Darwin","Milano Marcello","Milano Sardegna","Gorgonzola","Legnano","Rho","Sesto San Giovanni","Milano Linate Aeroporto"],
    "MONZA E BRIANZA": ["Sede centrale","Desio","Seregno"],
    "PAVIA": ["Sede centrale","Broni","Vigevano","Voghera"],
    "SONDRIO": ["Sede centrale","Mese","Morbegno","Tirano","Valdisotto"],
    "VARESE": ["Sede centrale","Busto Arsizio","Ispra","Luino","Saronno","Somma Lombardo","Milano Malpensa Aeroporto"]
  },
  "Marche": {
    "ANCONA": ["Sede centrale","Arcevia","Fabriano","Jesi","Osimo","Senigallia","Ancona Aeroporto"],
    "ASCOLI PICENO": ["Sede centrale","San Benedetto del Tronto"],
    "FERMO": ["Sede centrale","Amandola"],
    "MACERATA": ["Sede centrale","Camerino","Civitanova Marche","Tolentino","Visso"],
    "PESARO E URBINO": ["Sede centrale","Cagli","Fano","Macerata Feltria","Urbino"]
  },
  "Molise": {
    "CAMPOBASSO": ["Sede centrale","Santa Croce di Magliano","Termoli"],
    "ISERNIA": ["Sede centrale","Agnone"]
  },
  "Piemonte": {
    "ALESSANDRIA": ["Sede centrale","Acqui Terme","Casale Monferrato","Novi Ligure","Ovada","Tortona"],
    "ASTI": ["Sede centrale"],
    "BIELLA": ["Sede centrale"],
    "CUNEO": ["Sede centrale","Alba","Mondovì","Saluzzo","Cuneo Aeroporto"],
    "NOVARA": ["Sede centrale","Arona","Borgomanero"],
    "TORINO": ["Sede centrale","Torino Centro","Torino Lingotto","Torino Stura","Chieri","Grugliasco","Ivrea","Pinerolo","Susa","Torino Aeroporto"],
    "VERBANO-CUSIO-OSSOLA": ["Sede centrale","Domodossola"],
    "VERCELLI": ["Sede centrale","Livorno Ferraris","Varallo"]
  },
  "Puglia": {
    "BARI": ["Sede centrale","Bari Carrassi","Bari Fiera","Altamura","Corato","Molfetta","Monopoli","Putignano","Bari Aeroporto"],
    "BARLETTA-ANDRIA-TRANI": ["Sede centrale"],
    "BRINDISI": ["Sede centrale","Francavilla Fontana","Ostuni","Brindisi Aeroporto"],
    "FOGGIA": ["Sede centrale","Cerignola","Deliceto","Lucera","Manfredonia","San Giovanni Rotondo","San Severo","Vico del Gargano"],
    "LECCE": ["Sede centrale","Gallipoli","Maglie","Tricase","Veglie"],
    "TARANTO": ["Sede centrale","Taranto città","Castellaneta","Manduria","Martina Franca","Taranto Aeroporto"]
  },
  "Sardegna": {
    "CAGLIARI": ["Sede centrale","Cagliari Città","Carbonia","Iglesias","Mandas","San Vito","Sanluri","Cagliari Aeroporto"],
    "NUORO": ["Sede centrale","Lanusei","Macomer","Siniscola","Sorgono","Tortolì"],
    "ORISTANO": ["Sede centrale","Abbasanta","Ales","Cuglieri"],
    "SASSARI": ["Sede centrale","Alghero","Arzachena","Bono","La Maddalena","Olbia","Ozieri","Porto Torres","Tempio Pausania","Alghero Aeroporto","Olbia Aeroporto"]
  },
  "Sicilia": {
    "AGRIGENTO": ["Sede centrale","Canicattì","Lampedusa","Licata","Santa Margherita di Belice","Sciacca","Lampedusa Aeroporto"],
    "CALTANISSETTA": ["Sede centrale","Gela","Mazzarino","Mussomeli"],
    "CATANIA": ["Sede centrale","Catania Nord","Catania Sud","Acireale","Adrano","Caltagirone","Palagonia","Paternò","Randazzo","Riposto","Catania Aeroporto"],
    "ENNA": ["Sede centrale","Leonforte","Nicosia","Piazza Armerina"],
    "MESSINA": ["Sede centrale","Messina Nord","Lipari","Milazzo","Patti","Roccalumera","Sant'Agata di Militello","Taormina"],
    "PALERMO": ["Sede centrale","Palermo Brancaccio","Palermo Nord","Palermo Sud","Cefalù","Corleone","Partinico","Petralia Soprana","Termini Imerese","Palermo Punta Raisi Aeroporto"],
    "RAGUSA": ["Sede centrale","Modica","Vittoria","Comiso Aeroporto"],
    "SIRACUSA": ["Sede centrale","Augusta","Lentini","Noto","Palazzolo Acreide","Priolo Gargallo"],
    "TRAPANI": ["Sede centrale","Alcamo","Castelvetrano","Marsala","Mazara del Vallo","Pantelleria","Pantelleria Aeroporto","Trapani Birgi Aeroporto"]
  },
  "Toscana": {
    "AREZZO": ["Sede centrale","Bibbiena","Cortona","Montevarchi"],
    "FIRENZE": ["Sede centrale","Firenze Ovest","Barberino del Mugello","Borgo San Lorenzo","Castelfiorentino","Empoli","Figline e Incisa Valdarno","Pontassieve","San Casciano in Val di Pesa","Firenze Aeroporto"],
    "GROSSETO": ["Sede centrale","Arcidosso","Follonica","Orbetello"],
    "LIVORNO": ["Sede centrale","Cecina","Piombino","Portoferraio"],
    "LUCCA": ["Sede centrale","Castelnuovo di Garfagnana","Pietrasanta","Viareggio"],
    "MASSA-CARRARA": ["Sede centrale","Aulla","Carrara"],
    "PISA": ["Sede centrale","Cascina","Castelfranco di Sotto","Volterra","Pisa Aeroporto"],
    "PISTOIA": ["Sede centrale","Montecatini Terme","Pescia","San Marcello Piteglio"],
    "PRATO": ["Sede centrale","Montemurlo"],
    "SIENA": ["Sede centrale","Montalcino","Montepulciano","Piancastagnaio","Poggibonsi"]
  },
  "Umbria": {
    "PERUGIA": ["Sede centrale","Perugia Cavour","Assisi","Città di Castello","Foligno","Gubbio","Nocera Umbra","Spoleto","Todi","Norcia","Perugia Aeroporto"],
    "TERNI": ["Sede centrale","Amelia","Orvieto"]
  },
  "Veneto": {
    "BELLUNO": ["Sede centrale","Agordo","Cortina d'Ampezzo","Feltre","Pieve di Cadore","Santo Stefano di Cadore"],
    "PADOVA": ["Sede centrale","Abano Terme","Cittadella","Este","Piove di Sacco"],
    "ROVIGO": ["Sede centrale","Adria","Castelmassa"],
    "TREVISO": ["Sede centrale","Castelfranco Veneto","Conegliano","Montebelluna","Motta di Livenza","Vittorio Veneto","Treviso Aeroporto"],
    "VENEZIA": ["Sede centrale","Venezia Lido","Venezia Marghera","Venezia Mestre","Cavarzere","Chioggia","Jesolo","Mira","Mirano","Portogruaro","San Donà di Piave","Venezia Aeroporto"],
    "VERONA": ["Sede centrale","Bardolino","Caldiero","Legnago","Valpolicella","Verona Aeroporto"],
    "VICENZA": ["Sede centrale","Arzignano","Asiago","Bassano del Grappa","Lonigo","Schio"]
  },
  "Nazionale": {
    "CON": []
  }
};

/** Lista regioni in ordine alfabetico + "Nazionale" in fondo */
export const VVF_REGIONI = [
  ...Object.keys(VVF_DATA).filter(r => r !== "Nazionale").sort(),
  "Nazionale",
];

/** Comandi di una regione.
 *  - Regioni normali: prepende "DIR. REG. [REGIONE]" all'elenco comandi
 *  - "Nazionale": restituisce solo ["CON"]
 */
export const getComandi = (regione) => {
  if (!regione || !VVF_DATA[regione]) return [];
  if (regione === "Nazionale") return ["CON"];
  const comandi = Object.keys(VVF_DATA[regione]).sort();
  return [`DIR. REG. ${regione.toUpperCase()}`, ...comandi];
};

/** Sedi di un comando in una regione */
export const getSedi = (regione, comando) =>
  regione && comando && VVF_DATA[regione]?.[comando]
    ? [...VVF_DATA[regione][comando]]
    : [];
